import { subscribe } from '../../common/errors/sagas';
import { notificationError } from '../../common/errors/notificationTypes';

const pre = 'IMCALCULATION/';

export const IM_CALCULATION_LOADED = `${pre}IM_CALCULATION_LOADED`;
export const SET_INITIALISED = `${pre}SET_INITIALISED`;
export const SET_LOADING = `${pre}SET_LOADING`;
export const SET_ROWS = `${pre}SET_ROWS`;
export const FETCH_DATA_FAILED = `${pre}FETCH_DATA_FAILED`;
export const SET_CSAS = `${pre}SET_CSAS`;

subscribe(FETCH_DATA_FAILED, 'Failed to fetch data', notificationError);

export const fetchDataFailed = error => ({
    type: FETCH_DATA_FAILED,
    error
});

export const imCalculationLoaded = search => ({
    type: IM_CALCULATION_LOADED,
    search
});

export const setCsas = csas => ({
    type: SET_CSAS,
    csas
});

export const setInitialised = initialised => ({
    type: SET_INITIALISED,
    initialised
});

export const setLoading = loading => ({
    type: SET_LOADING,
    loading
});

export const setRows = (rows, serverFilters) => ({
    type: SET_ROWS,
    rows,
    serverFilters
});
